import { useState, useEffect } from "react";
import { isMobile } from "../utils/helpers";
export function useKeyboardOpened() {
  const [open, setOpen] = useState(false);

  const isInput = el => {
    return el.target.tagName === "INPUT" && el.target.type !== "radio" || el.target.tagName === "TEXTAREA";
  };

  const showKeyboard = element => isInput(element) && setOpen(true);

  const hideKeyboard = element => isInput(element) && setOpen(false);

  const createMobileListener = () => {
    document.addEventListener("focusin", showKeyboard);
    document.addEventListener("focusout", hideKeyboard);
    return () => {
      document.removeEventListener("focusin", showKeyboard);
      document.removeEventListener("focusout", hideKeyboard);
    };
  };

  useEffect(isMobile ? createMobileListener : () => undefined, []);
  return open;
}